module.exports = __webpack_public_path__ + "images/bannerPT-e3a3325b47ac74e10fc9d4a488fd7ebe.jpg";